import { Box, Typography } from '@mui/material';
import React from 'react';

import { DATA_TEST } from '../enums';
import { MuiSxProps } from '../types';


interface IErrorProps {
  styleOverrides?: MuiSxProps;
}

export const Error = ({ styleOverrides }: IErrorProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        maxWidth: 240,
        ...styleOverrides
      }}
      data-test={DATA_TEST.context_switcher_error}
    >
      <Typography sx={{ color: 'text.primary', textAlign: 'center' }}>
        Could not load your entities and applications
      </Typography>
      <Typography variant="bodyXSmall" sx={{ color: 'text.secondary', textAlign: 'center' }}>
        Try refreshing the page or try again later
      </Typography>
    </Box>
  );
};
